(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cover-addons-bundle"]) return;
  try {
    
  $(document).on('click', '.select-bundle-btn', function (e) {
    e.preventDefault();

    let $clicked = $(this);
    let bundleTitle = $clicked.attr('data-bundle-foption');
    let includedTitles = ($clicked.attr('data-bundle-includes') || '')
      .split(',')
      .map(function (t) {
        return t.trim();
      })
      .filter(Boolean);

    let bundleItem = $('#cvrbundle-selector li[data-title="' + bundleTitle + '"]');
    let bundleId = bundleItem.attr('data-id');
    let bundlePrice = parseFloat(bundleItem.attr('data-price')) || 0;

    if (typeof window.pprice === 'undefined' || isNaN(window.pprice)) {
      window.pprice = 0;
    }
    if (!Array.isArray(window.prodToCart)) {
      window.prodToCart = [];
    }

    let $card = $clicked.closest('.bundle-card');
    let isCurrentlySelected = $card.hasClass('bundle-selected');

    // function setIncludedAddonsLocked(locked) {
    //   includedTitles.forEach(function (title) {
    //     let $addonBtn = $(
    //       '#shopify-section-cover-addons .action-button a.cover-addons-select[data-foption="' + title + '"]'
    //     );
    //     let $addonWrapper = $addonBtn.closest('.pc-entry');

    //     if (locked) {
    //       // If the shopper already had this addon individually selected, undo it
    //       // and refund its price before locking, so it isn't double counted.
    //       let $btnWrapper = $addonBtn.closest('.action-button');
    //       if ($btnWrapper.hasClass('selected')) {
    //         $btnWrapper.trigger('click');
    //       }
    //       $addonWrapper.addClass('addon-in-bundle');
    //     } else {
    //       $addonWrapper.removeClass('addon-in-bundle');
    //     }
    //   });
    // }

    function setIncludedAddonsLocked(locked) {
      includedTitles.forEach(function (title) {
        let $addonBtn = $(
          '#shopify-section-cover-addons .action-button a.cover-addons-select[data-foption="' + title + '"]'
        );
        let $btnWrapper = $addonBtn.closest('.action-button');
        let $addonWrapper = $addonBtn.closest('.pc-entry');

        if (locked) {
          let wasIndividuallySelected = $btnWrapper.hasClass('selected');

          // Remember whether the shopper had already picked this addon
          // themselves, so we restore the right state on un-select.
          $addonWrapper.attr('data-was-individually-selected', wasIndividuallySelected ? '1' : '0');

          if (!wasIndividuallySelected) {
            // Wasn't selected before -> just force the visual "Added" state.
            // Do NOT trigger a real click, so it never gets pushed into
            // window.prodToCart or counted twice - the bundle price covers it.
            $btnWrapper.addClass('selected');
            $addonBtn.text('Added');
          } else {
            // Was already individually selected -> keep the visual state,
            // but stop double counting its price. Remove its own line
            // item from prodToCart since the bundle line item now
            // covers it. ADJUST data-variant-id below to match whatever
            // attribute your addon-select script actually stores the id on.
            let addonId = $addonBtn.attr('data-variant-id');
            if (addonId && Array.isArray(window.prodToCart)) {
              window.prodToCart = window.prodToCart.filter(function (item) {
                return item.id != addonId;
              });
            }
          }

          $addonWrapper.addClass('addon-in-bundle');
        } else {
          let wasIndividuallySelected = $addonWrapper.attr('data-was-individually-selected') === '1';

          if (!wasIndividuallySelected) {
            $btnWrapper.removeClass('selected');
            $addonBtn.text('Add');
          }
          // If it WAS individually selected, leave .selected as-is —
          // sumSelectedAddons() will pick its price back up automatically
          // now that .addon-in-bundle is being removed below.

          $addonWrapper.removeClass('addon-in-bundle');
          $addonWrapper.removeAttr('data-was-individually-selected');
        }
      });
    }

    if (isCurrentlySelected) {
      // Deselect bundle
      $card.removeClass('bundle-selected');
      $clicked.text('Select Bundle');
      window.pprice -= bundlePrice;
      window.prodToCart = window.prodToCart.filter(function (item) {
        return item.id != bundleId;
      });
      setIncludedAddonsLocked(false);
      window.selectedBundleName = null;
      window.selectedBundlePrice = 0;
    } else {
      // Deselect any other active bundle first (one bundle at a time)
      $('.bundle-card.bundle-selected').each(function () {
        $(this).find('.select-bundle-btn').trigger('click');
      });

      // Select this bundle
      $card.addClass('bundle-selected');
      $clicked.text('Selected');
      window.pprice += bundlePrice;
      window.prodToCart.push({ id: bundleId, quantity: 1 });
      setIncludedAddonsLocked(true);
      window.selectedBundleName = bundleTitle;
      window.selectedBundlePrice = bundlePrice;
    }

    $('.product-total-price strong').text('$' + window.pprice.toFixed(2));
    if (typeof window.recalcAddonsAndLifters === 'function') {
      window.recalcAddonsAndLifters();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cover-addons-new"]) return;
  try {
    
  $(document).ready(function () {
    //   $('.pc-entry.addon').slice(3).hide();
    // // Track the toggle state
    // let isExpanded = false;
    // $('.view-more-btn').click(function(e){
    //     e.preventDefault();
    //     if (isExpanded) {
    //         // Hide additional blocks
    //         $('.pc-entry.addon').slice(3).slideUp();
    //         $(this).text('View More');
    //     } else {
    //         // Show additional blocks
    //         $('.pc-entry.addon').slice(3).slideDown();
    //         $(this).text('View Less');
    //     }
    //     // Toggle the state
    //     isExpanded = !isExpanded;
    // });
  });
  // Get the buttons and popup elements
  let btns = document.querySelectorAll('.addon-expand-icon');
  let popup = document.getElementById('addonPopup');

  // Get the close button
  let closeBtn = document.getElementsByClassName('addon_close_popup')[0];

  function openPopup(e, btn) {
    const img = document.getElementById('pop-addon-image');
    // Get the src of the image
    const imgSrc = img ? img.src : null;
    let img_src = btn.getAttribute('src');
    let img_element = document.getElementById('pop-addon-image');
    img_element.src = img_src;

    popup.style.display = 'block';
  }

  // Function to close the popup
  function closePopup() {
    popup.style.display = 'none';
  }

  // Double click event listener to open the popup for each button
  btns.forEach(function (btn) {
    let button = btn.parentElement.firstElementChild;
    btn.addEventListener('click', function (event) {
      openPopup(event, button);
    });
  });

  // Click event listener to close the popup when clicking on the close button
  closeBtn.addEventListener('click', closePopup);

  // Click event listener to close the popup when clicking anywhere outside of it
  window.addEventListener('click', function (event) {
    if (event.target == popup) {
      closePopup();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cover-addons"]) return;
  try {
    
  $(document).ready(function () {

  let btns = document.querySelectorAll('.addon-expand-icon');
  let popup = document.getElementById('addonPopup');

  // Get the close button
  let closeBtn = document.getElementsByClassName('addon_close_popup')[0];

  function openPopup(e, btn) {
  const img = document.getElementById('pop-addon-image');
  // Get the src of the image
  const imgSrc = img ? img.src : null;
  let img_src = btn.getAttribute('src');
  let img_element = document.getElementById('pop-addon-image');
  img_element.src = img_src;

  popup.style.display = 'block';
  }

  // Function to close the popup
  function closePopup() {
  popup.style.display = 'none';
  }

  // Double click event listener to open the popup for each button
  btns.forEach(function (btn) {
  let button = btn.parentElement.firstElementChild;
  btn.addEventListener('click', function (event) {
  openPopup(event, button);
  });
  });

  // Click event listener to close the popup when clicking on the close button
  closeBtn.addEventListener('click', closePopup);

  // Click event listener to close the popup when clicking anywhere outside of it
  window.addEventListener('click', function (event) {
  if (event.target == popup) {
  closePopup();
  }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-carousel"] && !Shopify.designMode) return;
  try {
    
   $(document).ready(function(){
     $('.image-carousel').owlCarousel({
      margin:10,
      nav:true,
      autoHeight:true,
      responsive:{
          0:{
              items:1
          },
          600:{
              items:1
          },
          1000:{
              items:2,
          }
      }
  })
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-colors"]) return;
  try {
    
  document.getElementById('wtshield').addEventListener('change', myFunction);

  // Function to handle the change event
  function myFunction() {
    var x = document.getElementById('wtshield').value;
  }

  // Get the buttons and popup elements
  var btns = document.querySelectorAll('.popupcolorBtn');

  var popup = document.getElementById('colorPopup');

  // Get the close button
  var closeBtn = document.getElementsByClassName('close_popup')[1];

  // Function to open the popup
  function openPopup(e) {
    // always the <a> itself
    var anchor = e.currentTarget;

    // color name from span inside anchor
    var color_name = anchor.querySelector('span').textContent;
    var color_element = document.getElementById('vinyl-color-name');
    color_element.innerHTML = color_name;

    // image source from data-content of <a>
    var img_src = anchor.dataset.content;
    var img_element = document.getElementById('pop-color-image');
    img_element.src = img_src;

    popup.style.display = 'block';
  }

  // Function to close the popup
  function closePopup() {
    popup.style.display = 'none';
  }

  // Double click event listener to open the popup for each button
  btns.forEach(function (btn) {
    btn.addEventListener('dblclick', openPopup);
  });

  // Click event listener to close the popup when clicking on the close button
  closeBtn.addEventListener('click', closePopup);

  // Click event listener to close the popup when clicking anywhere outside of it
  window.addEventListener('click', function (event) {
    if (event.target == popup) {
      closePopup();
    }
  });
  document.querySelectorAll('.color-container a.popupcolorBtn').forEach(function (link) {
  link.addEventListener('click', function () {
    setTimeout(function () {
      document.querySelectorAll('.fabric-select-btn').forEach(function (btn) {
        var parentLink = btn.closest('a');
        if (parentLink) {
          btn.textContent = parentLink.classList.contains('selected') ? 'Unselect' : 'Select';
        }
      });
    }, 0);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-fixedsize-color-swatches"]) return;
  try {
    
  // ---------- swatch selection (visual only — hooks into the summary
  // panel fields if/when you wire that up) ----------
  (function () {
    var items = document.querySelectorAll('.mc-swatch-item');

    items.forEach(function (item) {
      var btn = item.querySelector('.mc-swatch-btn');
      if (!btn) return;

   
    });
  })();

  // ---------- HydroTex popup (double-click preview) ----------
  (function () {
    var btns = document.querySelectorAll('.hydrotex-swatch');
    var popup = document.getElementById('myPopupCombo');
    var closeBtn = document.querySelector('.hydrotex-close');
    if (!popup) return;

    function openPopup(e) {
      e.preventDefault();
      var btn = e.currentTarget;
      var label = btn.querySelector('.mc-swatch-label') ? btn.querySelector('.mc-swatch-label').textContent : '';
      var nameEl = document.getElementById('color-name-hydrotex-combo');
      if (nameEl) nameEl.innerHTML = label;
      var imgEl = document.getElementById('pop-image-hydrotex-combo');
      var img_src = btn.dataset.content;
      if (imgEl && img_src) imgEl.src = img_src;
      popup.style.display = 'block';
    }
    function closePopup() { popup.style.display = 'none'; }

    btns.forEach(function (btn) { btn.addEventListener('dblclick', openPopup); });
    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    window.addEventListener('click', function (event) { if (event.target == popup) closePopup(); });
  })();

  // ---------- Marine Vinyl popup (double-click preview) ----------
  (function () {
    var btns = document.querySelectorAll('.marine-swatch');
    var popup = document.getElementById('colorPopupCombo');
    var closeBtn = document.querySelector('.marine-close');
    if (!popup) return;

    function openPopup(e) {
      e.preventDefault();
      e.stopPropagation();
      var btn = e.currentTarget;
      var label = btn.querySelector('.mc-swatch-label') ? btn.querySelector('.mc-swatch-label').textContent : '';
      var nameEl = document.getElementById('vinyl-color-name-marine-combo');
      if (nameEl) nameEl.innerHTML = label;
      var imgEl = document.getElementById('pop-color-image-marine-combo');
      var img_src = btn.dataset.content;
      if (imgEl && img_src) imgEl.src = img_src;
      popup.style.display = 'block';
    }
    function closePopup() { popup.style.display = 'none'; }

    btns.forEach(function (btn) { btn.addEventListener('dblclick', openPopup); });
    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    window.addEventListener('click', function (event) { if (event.target == popup) closePopup(); });
  })();

  (function () {
  var items = document.querySelectorAll('.mc-swatch-item');
  var previewImg = document.getElementById('colorPreviewImg');
  var previewBadge = document.getElementById('colorPreviewBadge');
  var previewDot = document.getElementById('colorPreviewDot');
  var previewName = document.getElementById('colorPreviewName');
  var previewMaterialEl = document.getElementById('colorPreviewMaterial');
  var defaultImg = previewImg ? previewImg.getAttribute('src') : '';
  var selected = null; // holds the clicked/locked-in preview state

  function materialLabel(material) {
    return material === 'hydrotex' ? 'HydroTex Pro 600D' : 'Marine Vinyl';
  }

  function renderPreview(state) {
    if (!previewImg) return;
    if (!state) {
      previewImg.src = defaultImg;
      if (previewBadge) previewBadge.style.display = 'none';
      if (previewMaterialEl) previewMaterialEl.textContent = 'Hover a color to preview';
      return;
    }
    previewImg.src = state.img || defaultImg;
    if (previewDot) previewDot.style.backgroundImage = state.dot ? 'url(' + state.dot + ')' : 'none';
    if (previewName) previewName.textContent = state.label || '';
    if (previewMaterialEl) previewMaterialEl.textContent = materialLabel(state.material);
    if (previewBadge) previewBadge.style.display = 'flex';
  }

  items.forEach(function (item) {
    var btn = item.querySelector('.mc-swatch-btn');
    if (!btn) return;

    var material = item.dataset.colorMaterial;
    var label = item.dataset.colorLabel || '';
    var previewSrc = btn.dataset.previewImg || btn.dataset.content;
    var dotSrc = btn.dataset.content;

    // HOVER — temporary preview, doesn't touch selection/summary
    btn.addEventListener('mouseenter', function () {
      if (btn.disabled) return;
      renderPreview({ img: previewSrc, label: label, material: material, dot: dotSrc });
    });
    btn.addEventListener('mouseleave', function () {
      renderPreview(selected); // fall back to the locked-in selection (or default)
    });

    // CLICK — locks the selection in, updates summary + preview
    btn.addEventListener('click', function () {
      if (btn.disabled) return;

      document.querySelectorAll('.mc-swatch-item.mc-selected').forEach(function (sel) {
        sel.classList.remove('mc-selected');
      });
      item.classList.add('mc-selected');

      selected = { img: previewSrc, label: label, material: material, dot: dotSrc };
      renderPreview(selected);

      var summaryMaterial = document.getElementById('summaryMaterial');
      var summaryColor = document.getElementById('summaryColor');
      var summaryMaterialPrice = document.getElementById('summaryMaterialPrice');
      var summaryTotal = document.getElementById('summaryTotal');
      var summaryBasePrice = document.getElementById('summaryBasePrice');

      if (summaryMaterial) summaryMaterial.textContent = materialLabel(material);
      if (summaryColor) summaryColor.textContent = label;

      var materialPrice = material === 'hydrotex' ? (parseFloat(btn.dataset.colorPrice) || 0) : 0;
      if (summaryMaterialPrice) summaryMaterialPrice.textContent = '$' + materialPrice.toFixed(2);
      if (summaryTotal && summaryBasePrice) {
        var baseVal = parseFloat(summaryBasePrice.textContent.replace(/[^0-9.]/g, '')) || 0;
        summaryTotal.textContent = '$' + (baseVal + materialPrice).toFixed(2);
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-strap-location"]) return;
  try {
    
  $(document).ready(function(){
       $(".strap-box").click(function(){
         $(".overlay, .toggle_element").show();
       });

       $(".close_popup, .overlay").click(function(){
         $(".overlay, .toggle_element").hide();
       });
     });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-weathershield"]) return;
  try {
    
function dimensionsFilled() {
  var dima = document.getElementById('dima');
  if (!dima || dima.value.trim() === '') {
    return false;
  }
  return true;
}

function toggleColorLock() {
  var wrapper = document.querySelector('.vinyl-color-wrapper');
  if (!wrapper) return;
  if (dimensionsFilled()) {
    wrapper.classList.remove('locked');
  } else {
    wrapper.classList.add('locked');
  }
}


// document.addEventListener('DOMContentLoaded', function() {
//   toggleColorLock();
//   toggleDimensionAlert();
//   var dimaInput = document.getElementById('dima');
//   if (dimaInput) {
//     dimaInput.addEventListener('input', toggleColorLock);
//     dimaInput.addEventListener('input', toggleDimensionAlert);
//   }
// });
document.addEventListener('DOMContentLoaded', function () {
  toggleColorLock();
  var dimaInput = document.getElementById('dima');
  if (dimaInput) {
    dimaInput.addEventListener('input', toggleColorLock);
  }
});


      
   var btns = document.querySelectorAll(".popupBtn");

   var popup = document.getElementById("myPopup");


   var closeBtn = document.getElementsByClassName("close_popup")[0];

  
  function openPopup(e) {

  var anchor = e.currentTarget;

 
  var color_name = anchor.querySelector("span").textContent;
  document.getElementById("color-name").innerHTML = color_name;

  var img_src = anchor.dataset.content;
  document.getElementById("pop-image").src = img_src;

  popup.style.display = "block";
}

 
   function closePopup() {
     popup.style.display = "none";
   }

   
   btns.forEach(function(btn) {

     btn.addEventListener("dblclick", openPopup);
   });

   
   closeBtn.addEventListener("click", closePopup);

  
   window.addEventListener("click", function(event) {
     if (event.target == popup) {
       closePopup();
     }
   });



   

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["specifications-sec"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const thumbnails = document.querySelectorAll('.thumbnail');
  const displayedImage = document.getElementById('displayed-image');

  thumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener('click', function () {
      const fullSrc = this.dataset.fullSrc || this.src;
      const fullSrcset = this.dataset.srcset || '';

      displayedImage.src = fullSrc;
      displayedImage.srcset = fullSrcset;
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whsield-carousel"]) return;
  try {
    
   $(document).ready(function(){
     $('#image-carousel').owlCarousel({
      margin:10,
      nav:true,
      autoHeight:true,
      responsive:{
          0:{
              items:1
          },
          600:{
              items:1
          },
          1000:{
              items:1,
          }
      }
  })
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-my-spa-cover"]) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
      const headers = document.querySelectorAll('.accordion-header');
      const contents = document.querySelectorAll('.accordion-content');

      // Open the first accordion by default
      if (contents.length > 0) {
          contents[0].style.maxHeight = contents[0].scrollHeight + 'px';
          headers[0].querySelector('.icon').textContent = '-';
      }

      headers.forEach((header, index) => {
          header.addEventListener('click', function() {
              const content = this.nextElementSibling;
              const isOpen = content.style.maxHeight;

              // Close all open accordion items
              contents.forEach((item, i) => {
                  item.style.maxHeight = null;
                  headers[i].querySelector('.icon').textContent = '+';
              });

              // Toggle current accordion item
              if (!isOpen) {
                  content.style.maxHeight = content.scrollHeight + 'px';
                  this.querySelector('.icon').textContent = '-';
              } else {
                  this.querySelector('.icon').textContent = '+';
              }
          });
      });
  });

  } catch(e) { console.error(e); }
})();
})();
